import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;

import JqueryFunctions from '../../../assets/js/Utility/JqueryFunctions.js';
JqueryFunctions();

// https://github.com/stefanpenner/es6-promise
require('es6-promise').polyfill();

import axios from 'axios';
window.axios = axios;

import Vue from 'vue';
Vue.prototype.$http = axios;
window.Vue = Vue;

import FactCheckWidgets from '../../../assets/js/FactCheck/HomeWidgets.js';
FactCheckWidgets();